// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1bz2v","footer":"ModalError_footer__1zCNv"};